/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactWithoutAccountModel
 */
export interface ContactWithoutAccountModel {
    /**
     * 
     * @type {string}
     * @memberof ContactWithoutAccountModel
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ContactWithoutAccountModel
     */
    last_name: string;
}

/**
 * Check if a given object implements the ContactWithoutAccountModel interface.
 */
export function instanceOfContactWithoutAccountModel(value: object): value is ContactWithoutAccountModel {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function ContactWithoutAccountModelFromJSON(json: any): ContactWithoutAccountModel {
    return ContactWithoutAccountModelFromJSONTyped(json, false);
}

export function ContactWithoutAccountModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactWithoutAccountModel {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
    };
}

export function ContactWithoutAccountModelToJSON(json: any): ContactWithoutAccountModel {
    return ContactWithoutAccountModelToJSONTyped(json, false);
}

export function ContactWithoutAccountModelToJSONTyped(value?: ContactWithoutAccountModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

